/**
 * Pure helper functions extracted from wizard_controller.js
 */

export function reorderArray(array, from, to) {
  const result = [...array]
  const [item] = result.splice(from, 1)
  result.splice(to, 0, item)
  return result
}

export function removeNewPhoto(ordered, selected, fileIndex) {
  const newOrdered = ordered.filter(p => !(p.type === 'new' && p.fileIndex === fileIndex))
  const newSelected = [...selected]
  newSelected.splice(fileIndex, 1)

  newOrdered.forEach(p => {
    if (p.type === 'new' && p.fileIndex > fileIndex) {
      p.fileIndex--
    }
  })

  return { ordered: newOrdered, selected: newSelected }
}

export function removePersistedPhoto(ordered, id) {
  return ordered.filter(p => !(p.type === 'persisted' && p.id === id))
}

export function filterImageFiles(files) {
  return files.filter(f => f.type.startsWith('image/'))
}

export function addFiles(ordered, selected, newFiles) {
  const imageFiles = filterImageFiles(newFiles)
  if (imageFiles.length === 0) return { ordered, selected, added: [] }

  const startIndex = selected.length
  const newSelected = selected.concat(imageFiles)
  const newEntries = imageFiles.map((_, i) => ({ type: 'new', fileIndex: startIndex + i }))
  const newOrdered = ordered.concat(newEntries)

  return { ordered: newOrdered, selected: newSelected, added: imageFiles }
}

export function buildFileOrder(ordered, selected) {
  const files = []
  ordered.forEach(entry => {
    if (entry.type === 'new') {
      const file = selected[entry.fileIndex]
      if (file) files.push(file)
    }
  })
  return files
}

export function buildPersistedImageOrder(ordered) {
  return ordered
    .filter(entry => entry.type === 'persisted')
    .map(entry => entry.id)
}

export function navigateIndex(current, direction, total) {
  return (current + direction + total) % total
}

export function formatCounter(index, total) {
  return `${index + 1}/${total}`
}
